import React, { useState } from "react";
import { Button, Image } from "react-bootstrap";
import EditOpenIssuesVendor from "../../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesVendor/InsideAllPageComponent/EditOpenIssuesVendor";
import moment from "moment";
import EditVendorOpenIssueSuggestion from "../EditIssuePopup/EditVendorOpenIssueSuggestion";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const OpenIssuesUsersTableBody = (props) => {
  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });
  return (
    <React.Fragment>
      <tbody key={props?.srno}>
        <tr className="super_admin_all_users_table_body">
          <td colSpan="6" className="p-0 w-100">
            <table className="w-100 HideShowTable">
              <tbody>
                <tr className="cursor" onClick={showTr}>
                  <td style={{ width: "10%" }}>
                    <div className="f12-500">{props.issuesData.issue_id}</div>
                    <div className="f12-500 mt-2">
                      {props.issuesData._id.substr(
                        props.issuesData._id.length - 10
                      )}
                    </div>
                  </td>
                  <td style={{ width: "16%" }}>
                    <div className="f12-500">
                      {props.issuesData && props.issuesData.issue_title}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="d-flex">
                      <div
                        className="f14-500"
                        // onClick={props.statusDropDownLink}
                      >
                        {props.statusDropDownText}
                      </div>
                      {/* <div>{props.statusDropDown}</div> */}
                    </div>
                  </td>
                  <td style={{ width: "12%" }}>
                    <div className="f12-400">
                      {props.issuesData &&
                        props.issuesData.category &&
                        props.issuesData.category.title}
                    </div>
                  </td>
                  <td style={{ width: "20%" }}>
                    <div className="f12-500">
                      {props.issuesData && props.issuesData.comment}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      {props.issuesData && props.issuesData.type}
                    </div>
                  </td>
                  <td style={{ width: "10%" }}>
                    <div className="f12-400">
                      {moment(
                        props.issuesData && props.issuesData.createdAt
                      ).format("Do MMM YYYY")}
                    </div>
                    <div className="f12-400">
                      {moment(
                        props.issuesData && props.issuesData.createdAt
                      ).format("hh:mm A")}
                    </div>
                  </td>
                  <td
                    style={{ width: "12%" }}
                    onClick={(e) => {
                      if (!e) var e = window.event;
                      e.cancelBubble = true;
                      if (e.stopPropagation) e.stopPropagation();
                    }}
                  >
                    <div className="d-flex align-items-center">
                      <Button
                        variant="link"
                        className="enIconBtn mr-3"
                        onClick={props.viewTicket}
                      >
                        <Image
                          fluid
                          alt="View"
                          title="View"
                          src={require("../../../../assets/images/UserManagement/eye.svg")}
                        />
                      </Button>
                      {/* <EditOpenIssuesVendor /> */}
                      <EditVendorOpenIssueSuggestion
                        editData={props && props.issuesData}
                      />
                    </div>
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <tr className="border-top">
                    <td style={{ width: "20%" }}>
                      <div className="f12-700 pb-2">Uploaded Photos</div>
                      <div className="d-flex align-items-center">
                        {props.issuesData &&
                          props.issuesData.attachment &&
                          props.issuesData.attachment.map((photo, index) => {
                            return (
                              <React.Fragment key={index}>
                                <SimpleReactLightbox>
                                  <SRLWrapper options={options}>
                                    <div className="enIMG33 rounded-circle mr-2">
                                      <Image fluid src={photo} alt="Icon" />
                                    </div>
                                  </SRLWrapper>
                                </SimpleReactLightbox>
                              </React.Fragment>
                            );
                          })}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </React.Fragment>
  );
};
export default OpenIssuesUsersTableBody;
